import { render, staticRenderFns } from "./CommunicationEventNew.vue?vue&type=template&id=0dcfa1a3&"
import script from "./CommunicationEventNew.vue?vue&type=script&lang=js&"
export * from "./CommunicationEventNew.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationEventNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports